import { render, staticRenderFns } from "./RightPaneDb.vue?vue&type=template&id=1407c96c"
import script from "./RightPaneDb.ts?vue&type=script&lang=ts&external"
export * from "./RightPaneDb.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports